export const capitalizeFirstLetterOfEachWord = (sentence: string) => {
  const words = sentence.toLowerCase().split(" ");

  return words
    .map((word) => {
      return word[0]?.toUpperCase() + word.slice(1);
    })
    .join(" ");
};
